'use client';

import React from "react";
import Image from "next/image";
import { useTranslations } from '../utils/translations';

interface TarotSymbolsSectionProps {
  className?: string;
}

export default function TarotSymbolsSection({ className = "" }: TarotSymbolsSectionProps) {
  const { t } = useTranslations();
  
  return (
    <div className={`flex gap-[30px] sm:gap-[40px] md:gap-[50px] justify-center items-center ${className}`}>
      <Image
        src="/images/img_vector_purple_500_144x150.svg"
        alt={t('home.tarot_symbols.accessibility.lenormand_method_alt')}
        width={150}
        height={144}
        className="w-[100px] sm:w-[125px] md:w-[150px] h-auto object-contain"
      />
      <Image
        src="/images/img_vector_white_a700_140x102.svg"
        alt={t('home.tarot_symbols.accessibility.rating_alt')}
        width={102}
        height={140}
        className="w-[70px] sm:w-[85px] md:w-[102px] h-auto object-contain"
      />
    </div>
  );
}
